/** The name in the browser tab, after each page's title. «(Beta)» goes when PolitorAI leaves the beta,
 *  with the label beside the logo (AppHeader.tsx) and the title of index.html. */
export const SITE_TITLE = "Politor AI (Beta)";

/** The version of package.json, inlined by Vite (`define` in vite.config.ts). */
export const APP_VERSION: string = __APP_VERSION__;

/** The line at the bottom of the user menu: the package's version and the build config.js names (a commit, or dev). */
export const versionLabel = (build: string) => `Versione ${APP_VERSION} · ${build}`;
